<template>

  <div style="height:150px;text-align:center;">
    <div style="margin-top:20px;">账户余额</div>
    <div style="margin-top:20px;">
      <span style="font-size:32px;">{{ account.balance }}</span>
      <span>元</span>
    </div>
    <div style="margin-top:30px;">
      <router-link to="/additional" class="t-addtinal">加款记录</router-link>
    </div>
  </div>

  <div class="separate"></div>

  <van-cell>账户加款</van-cell>
  <van-grid clickable square :column-num="3">
    <van-grid-item icon="card" icon-color="#ab5208" text="钱包地址" to="/unionpay-transfor" />
    <van-grid-item icon="alipay" icon-color="#1296db" text="支付宝转账" to="/alipay-transfor" />
    <van-grid-item icon="wechat" icon-color="#0e932e" text="微信转账" to="/wechatpay-transfor" />
  </van-grid>

  <div class="separate"></div>

  <van-cell>手机充值</van-cell>
  <van-grid clickable square :column-num="3">
    <van-grid-item icon="balance-list-o" icon-color="#1989fa" text="话费充值" to="/" />
    <van-grid-item icon="search" icon-color="#1989fa" text="话费查单" to="/search" />
    <van-grid-item icon="todo-list-o" icon-color="#1989fa" text="充值记录" to="/order" />
  </van-grid>

</template>

<script>
import { Grid, GridItem, Cell } from "vant";
import accountApi from '@/api/account'

export default {
  name: "Me",

  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Cell.name]: Cell
  },
  data() {
    return {
      account: {
        balance: 0
      }
    }
  },
  mounted() {
    let userId = this.$store.state.user.user.id;
    accountApi.getAccount(userId).then(res => {
      this.account = res.data
    })
  }
};
</script>

<style>
.separate {height: 10px; background-color: rgb(236, 232, 232);}
</style>
